export class ClaveValor {

    public id?:any;
    public valor?:any;
    
}
